import type { Row } from '../types'

interface DataTableProps {
  columns: string[]
  rows: Row[]
  maxHeight?: string
}

export default function DataTable({ columns, rows, maxHeight = '600px' }: DataTableProps) {
  return (
    <div 
      className="overflow-auto h-full" 
      style={{ maxHeight }}
    >
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50 sticky top-0 z-10">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              #
            </th>
            {columns.map((col) => (
              <th
                key={col}
                className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {rows.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-400">
                {row.row_number}
              </td>
              {columns.map((col) => (
                <td
                  key={col}
                  className="px-4 py-3 text-sm text-gray-900 max-w-xs truncate"
                  title={String(row.data[col] ?? '')}
                >
                  {row.data[col] != null ? String(row.data[col]) : ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
